import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from  'bootstrap-vue'

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
